/**
 * GlobalSpinner — Overlay de carga para operaciones de larga duración.
 *
 * Se renderiza en Layout.tsx y es visible en todas las rutas.
 * Se activa desde cualquier componente via useGlobalLoading().setLoading().
 */

import { Loader2 } from 'lucide-react';
import { useGlobalLoading } from '../../context/GlobalLoadingContext';

export default function GlobalSpinner() {
  const { loading, message } = useGlobalLoading();
  if (!loading) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center"
      style={{ background: 'var(--surface)', backdropFilter: 'blur(3px)' }}
      aria-live="polite"
      aria-label={message || 'Procesando'}
    >
      <div className="data-card rounded-xl shadow-2xl px-8 py-7 flex flex-col items-center gap-4 min-w-[220px]">
        <Loader2 size={32} className="text-[var(--brand)] animate-spin" />
        <p className="text-sm font-semibold text-[var(--surface)] text-center leading-snug max-w-[200px]">
          {message || 'Procesando…'}
        </p>
      </div>
    </div>
  );
}
